"use strict";

exports.__esModule = true;
exports.SPACING_TYPES = exports.INSET_SPACING_SIZE = exports.SPACING_SIZE = void 0;
var SPACING_SIZE = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl'
};
exports.SPACING_SIZE = SPACING_SIZE;
var INSET_SPACING_SIZE = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
exports.INSET_SPACING_SIZE = INSET_SPACING_SIZE;
var SPACING_TYPES = {
  marginHorizontal: 'inline',
  marginStart: 'inline',
  marginEnd: 'inline',
  marginLeft: 'inline',
  marginRight: 'inline',
  paddingHorizontal: 'inline',
  paddingStart: 'inline',
  paddingEnd: 'inline',
  paddingLeft: 'inline',
  paddingRight: 'inline',
  padding: 'inset',
  margin: 'stack',
  marginVertical: 'stack',
  marginTop: 'stack',
  marginBottom: 'stack',
  paddingVertical: 'stack',
  paddingTop: 'stack',
  paddingBottom: 'stack'
};
exports.SPACING_TYPES = SPACING_TYPES;